import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

function qs(params = {}) {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );
  return new URLSearchParams(clean).toString();
}

export function useProducts(params = {}, options = {}) {
  return useQuery({
    queryKey: ["products", params],
    queryFn: async () => (await api.get(`/products?${qs(params)}`)).data,
    keepPreviousData: true,
    enabled: options.enabled ?? true,
  });
}

export function useProduct(handle) {
  return useQuery({
    queryKey: ["product", handle],
    queryFn: async () => (await api.get(`/products/${handle}`)).data,
    enabled: !!handle,
  });
}

export function useFacets() {
  return useQuery({
    queryKey: ["facets"],
    queryFn: async () => (await api.get(`/products/facets`)).data,
  });
}

export function useCollections() {
  return useQuery({
    queryKey: ["collections"],
    queryFn: async () => (await api.get(`/collections`)).data,
  });
}

export function useCollection(handle, params = {}) {
  return useQuery({
    queryKey: ["collection", handle, params],
    queryFn: async () => (await api.get(`/collections/${handle}?${qs(params)}`)).data,
    enabled: !!handle,
    keepPreviousData: true,
  });
}

export function useTestimonials() {
  return useQuery({
    queryKey: ["testimonials"],
    queryFn: async () => (await api.get(`/testimonials`)).data,
  });
}

export function useImagery() {
  return useQuery({
    queryKey: ["imagery"],
    queryFn: async () => (await api.get(`/imagery`)).data,
  });
}
